(function($) {

    $(document).ready(function() {
        
        if ( $('h1 .title').length ) {
            $('h1 .title').each(function() {
                var title = $(this).html();
                var titles = title.split('/');
                for (var i = 0; i < titles.length; i++) {
                    var this_title = titles[i];
                    this_title = '<span class="nowrap">'+ $.trim(this_title) +'</span>';
                    titles[i] = this_title;
                }
                title = titles.join(' / ');
                $(this).html(title);
            });
        }

    });

})( jQuery );